import React, { Suspense } from 'react';
import { Route, Switch } from 'react-router-dom';
import Box from '../Box';
import CircularProgress from '../CircularProgress';
import SignUpScreen from '../../../containers/User/SignUpScreenContainer';
import SignInScreen from '../../../containers/User/SignInScreenContainer';
import DashboardScreen from '../../../containers/User/DashboardScreenContainer';
import WelcomeScreen from '../../User/WelcomeScreen';
import ClientCreateScreen from '../../../containers/User/ClientCreateScreenContainer';
import PaymentCalculationScreen from '../../../containers/Payment/PaymentCalculationScreenContainer';
import ReportsScreen from '../../Unknown/AdminPanel/Reports/Reports';
import AdminPanel from '../../Unknown/AdminPanel/AdminPanel';
import PartnersScreen from '../../Unknown/AdminPanel/Partners/Partners';
import RealtorsScreen from '../../Unknown/AdminPanel/Realtors/Realtors';
import withRouteProtection from '../withRouteProtection';
import useStyles from './styles';
import Footer from '../../Unknown/Footer';
import RealtorHomeScreen from '../../Unknown/RealtorHomeScreen/RealtorHomeScreen';
import RealtorSignUpScreenContainer from '../../../containers/User/RealtorSignUpScreenContainer';
import RealtorSignUpVerificationScreen from '../../User/RealtorSignUpVerificationScreen/RealtorSignUpVerificationScreen';
import IFrameDocumentContainer from '../../../containers/Unknown/IFrameDocumentContainer/IFrameDocumentContainer';
import {
  TERMS_URL,
  ABOUT_US_URL,
  PRIVACY_POLICY_URL
} from '../../../common/constants';
import HomeScreen from '../../Unknown/HomeScreen';

function Progress() {
  const classes = useStyles();
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      className={classes.progressContainer}
    >
      <CircularProgress />
    </Box>
  );
}

// `component`s should have same values to reuse them in `Switch`
// details are here: https://github.com/ReactTraining/react-router/issues/4578#issuecomment-282081567

export default function Routes() {
  const classes = useStyles();
  return (
    <Suspense fallback={<Progress />}>
      <Box className={classes.mainWrapper}>
        <Switch>
          <Route path="/" exact component={RealtorHomeScreen} />
          <Route path="/home" exact component={HomeScreen} />
          <Route path="/sign-up/:tenantSlug" exact component={SignUpScreen} />
          <Route
            path="/realtor-sign-up"
            exact
            component={RealtorSignUpScreenContainer}
          />
          <Route
            path="/account-verification"
            exact
            component={RealtorSignUpVerificationScreen}
          />
          <Route path="/sign-in" exact component={SignInScreen} />
          <Route
            path="/dashboard/:tenantName"
            exact
            component={withRouteProtection(DashboardScreen)}
          />
          <Route
            path="/welcome"
            exact
            component={withRouteProtection(WelcomeScreen)}
          />
          <Route
            path="/clients/create"
            exact
            component={withRouteProtection(ClientCreateScreen)}
          />
          <Route
            path="/clients/:id"
            exact
            component={withRouteProtection(PaymentCalculationScreen)}
          />
          <Route
            path="/terms"
            exact
            component={() => (
              <IFrameDocumentContainer
                url={TERMS_URL}
                title="Terms and Conditions"
              />
            )}
          />
          <Route
            path="/about-us"
            exact
            component={() => (
              <IFrameDocumentContainer url={ABOUT_US_URL} title="About Us" />
            )}
          />
          <Route
            path="/privacy-policy"
            exact
            component={() => (
              <IFrameDocumentContainer
                url={PRIVACY_POLICY_URL}
                title="Privacy Policy"
              />
            )}
          />
          <Route path="/admin-panel" exact component={AdminPanel} />
          <Route path="/admin-panel/reports" exact component={ReportsScreen} />
          <Route
            path="/admin-panel/partners"
            exact
            component={PartnersScreen}
          />
          <Route
            path="/admin-panel/realtors"
            exact
            component={RealtorsScreen}
          />
        </Switch>
        <Route path="/" component={Footer} />
      </Box>
    </Suspense>
  );
}
